import { render, staticRenderFns } from "./ImprimantesHpLatex530.vue?vue&type=template&id=72d68f72&scoped=true"
import script from "./ImprimantesHpLatex530.vue?vue&type=script&lang=js"
export * from "./ImprimantesHpLatex530.vue?vue&type=script&lang=js"
import style0 from "./ImprimantesHpLatex530.vue?vue&type=style&index=0&id=72d68f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d68f72",
  null
  
)

export default component.exports